/**
 * Gestor centralizado de toasts para evitar notificaciones duplicadas
 * y hacer las notificaciones menos intrusivas
 */

let lastOfflineToastTime = 0
let lastConnectionErrorToastTime = 0
let offlineToastShown = false
const OFFLINE_TOAST_COOLDOWN = 30000 // 30 segundos entre toasts de offline
const CONNECTION_ERROR_COOLDOWN = 5000 // 5 segundos entre toasts de error de conexión

/**
 * Muestra un toast de "Sin conexión" solo si no se ha mostrado recientemente
 * Este mensaje es informativo, no un error, así que lo hacemos menos intrusivo
 * Solo se muestra una vez por sesión para no ser molesto
 */
export function showOfflineToast(message: string = 'Sin conexión. Mostrando datos en caché.') {
  const now = Date.now()
  
  // Solo mostrar si han pasado al menos OFFLINE_TOAST_COOLDOWN ms Y no se ha mostrado antes
  if (offlineToastShown && (now - lastOfflineToastTime < OFFLINE_TOAST_COOLDOWN)) {
    return
  }
  
  lastOfflineToastTime = now
  offlineToastShown = true
  
  // No mostrar toast, solo log en consola para desarrollo
  // El usuario ya sabe que está offline porque ve los datos en caché
  // Mostrar toast sería redundante y molesto
  if (import.meta.env.DEV) {
    console.info(message)
  }
  
  // Resetear el flag después del cooldown para permitir mostrar de nuevo si es necesario
  setTimeout(() => {
    offlineToastShown = false
  }, OFFLINE_TOAST_COOLDOWN)
}

/**
 * Muestra un toast de error de conexión solo si no se ha mostrado recientemente
 */
export function showConnectionErrorToast(message: string = 'Error de conexión. Verifica tu conexión a internet.') {
  const now = Date.now()
  
  // Solo mostrar si han pasado al menos CONNECTION_ERROR_COOLDOWN ms
  if (now - lastConnectionErrorToastTime < CONNECTION_ERROR_COOLDOWN) {
    return
  }
  
  lastConnectionErrorToastTime = now
  
  // Importar toast dinámicamente para evitar dependencias circulares
  import('react-hot-toast').then(({ default: toast }) => {
    toast.error(message, {
      duration: 3000,
      id: 'connection-error', // ID único para evitar duplicados
    })
  })
}

